import { useCallback, useState } from 'react';
import {
  getValidToken,
  handleAuthenticationError,
  SessionExpiredError,
} from '../../util/sessionExpiry';

export const useFetch = (props?: UseFetchProps) => {
  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState<Response>();

  const doFetch = useCallback(
    async (url: string, options: RequestInit = {}) => {
      setLoading(true);
      try {
        if (!props?.noAuth) {
          const headers = new Headers(options.headers);
          headers.set('Authorization', await getValidToken());
          options = { ...options, headers };
        }
        const response = await fetch(`${props?.baseUrl || ''}${url}`, options);
        if (!props?.noAuth && response.status === 401) {
          handleAuthenticationError(response);
          throw new SessionExpiredError();
        }
        setResponse(response);
        return response;
      } finally {
        setLoading(false);
      }
    },
    [props],
  );

  return { fetch: doFetch, loading, response };
};

export interface UseFetchProps {
  noAuth?: boolean;
  baseUrl?: string;
}
